import { ReactComponent as AddCircle } from './svg/add-circle.svg';
import { ReactComponent as BadgeLogo } from './svg/badge.svg';
import { ReactComponent as BinLogo } from './svg/bin.svg';
import { ReactComponent as BlueArrowUpLogo } from './svg/blue-arrow-up.svg';
import { ReactComponent as BlueArrowLogo } from './svg/blue-arrow.svg';
import { ReactComponent as BuyCryptoLogo } from './svg/buy-crypto.svg';
import { ReactComponent as RedCloseCircleLogo } from './svg/close-circle.svg';
import { ReactComponent as Cup } from './svg/cup.svg';
import { ReactComponent as DiscordLogo } from './svg/discord.svg';
import { ReactComponent as InfoLogo } from './svg/info.svg';
import { ReactComponent as MapLogo } from './svg/map.svg';
import { ReactComponent as MercleLogoWhite } from './svg/mercle-logo-white.svg';
import { ReactComponent as MercleLogo } from './svg/mercle_black.svg';
import { ReactComponent as MoreElementLogo } from './svg/more-elements.svg';
import { ReactComponent as PeopleLogo } from './svg/people.svg';
import { ReactComponent as SearchLogo } from './svg/search.svg';
import { ReactComponent as SortLogo } from './svg/sort.svg';
import { ReactComponent as GreenTickLogo } from './svg/tick-circle.svg';
import { ReactComponent as TwitterFilled } from './svg/twitter-filled.svg';
import { ReactComponent as TwitterLogo } from './svg/twitter.svg';
import { ReactComponent as UserLogo } from './svg/user.svg';
import { ReactComponent as VerticleLine } from './svg/vertical-line.svg';

export default {
  dark: {
    search: MercleLogo,
  },
  light: {
    search: SearchLogo,
    mercle: MercleLogo,
    sort: SortLogo,
    info: InfoLogo,
    moreElement: MoreElementLogo,
    buyCrypto: BuyCryptoLogo,
    blueArrow: BlueArrowLogo,
    twitterLogo: TwitterLogo,
    verticalLine: VerticleLine,
    cup: Cup,
    addCircle: AddCircle,
    blueArrowUp: BlueArrowUpLogo,
    binLogo: BinLogo,
    greenTick: GreenTickLogo,
    redCloseCircle: RedCloseCircleLogo,
    mercleLogoWhite: MercleLogoWhite,
    map: MapLogo,
    people: PeopleLogo,
    user: UserLogo,
    discord: DiscordLogo,
    twitterFilled: TwitterFilled,
    badge: BadgeLogo,
  },
};
